import React from "react";
const CryptoHuntAttemptsCard = ({ attemptsLeft, className }) => {
  return (
    <div
      style={{
        boxShadow: "0 0 20px rgba(255,255,255,0.4) inset",
      }}
      className={`${className} text-base font-semibold  uppercase px-16 py-3  bg-black rounded-full border-2 border-primary`}
    >
      <h1>
        <span className="text-[#200052] font-bold">{attemptsLeft}</span> &nbsp;
        Tries Left
      </h1>
    </div>
  );
};

export default CryptoHuntAttemptsCard;
